module.exports = __webpack_public_path__ + "img/SES_38048420.495dc69b.jpg";